import serviceAxios from "../utils/http.js";

export function uploadFile(data) {
  return serviceAxios({
    url: "/PCwj/file/uploads",
    method: "post",
    data: data,
  });
}

// 问卷列表
export function userList(query) {
  return serviceAxios({
    url: "/PCwj/questionnaire/userList",
    method: "get",
    params: query,
  });
}
// 回收站列表
export function recycleBinList(query) {
  return serviceAxios({
    url: "/wj/questionnaire/recycleBinList",
    method: "get",
    params: query,
  });
}
// export const getUserInfo = (params) => ajax(`/wj/userInfo/`, params, 'POST');
// 用户信息
export function getUserInfo(data) {
  return serviceAxios({
    url: "/wj/userInfo/",
    method: "post",
    data,
  });
}
// 发布问卷
export const usercloseQuestionnaire = (data) => {
  return serviceAxios({
    url: "/wj/questionnaire/closeQuestionnaire",
    method: "post",
    data,
  });
};

// 结束问卷
export const closeQuestionnaire = (data) => {
  return serviceAxios({
    url: "/wj/questionnaire/closeQuestionnaire",
    method: "post",
    data,
  });
};

// 复制问卷
export const copyQuestionnaire = (data) => {
  return serviceAxios({
    url: "/wj/questionnaire/copyQuestionnaire",
    method: "post",
    data,
  });
};

// 回收站问卷设置
export const setRecycleQuestionnaire = (data) => {
  return serviceAxios({
    url: "/wj/questionnaire/setRecycleQuestionnaire",
    method: "post",
    data,
  });
};

export const templateList = (params) => {
  return serviceAxios({
    url: "/wj/questionnaireTemplate/templateTypeList",
    method: "get",
    params,
  });
};

export const questionnaireTemplateList = (params) => {
  return serviceAxios({
    url: "/wj/questionnaireTemplate/questionnaireTemplateList",
    method: "get",
    params,
  });
};

// 生成唯一活动ID
export const getUuid = (params) => {
  return serviceAxios({
    url: "/PCwj/questionnaire/getUuid",
    method: "get",
    params,
  });
};

// 新增修改用户问卷问题数据
export const saveQuestion = (data) => {
  return serviceAxios({
    url: "/PCwj/questionTemp/saveQuestion",
    method: "post",
    data,
  });
};

// 删除问卷
export const removeQuestionnaire = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaire/removeQuestionnaire",
    method: "post",
    data,
  });
};

// 用户创建问卷
export const createQuestionnaire = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaire/createQuestionnaire",
    method: "post",
    data,
  });
};

// 用户修改问卷
export const updateQuestionnaire = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaire/updateQuestionnaire",
    method: "post",
    data,
  });
};

// 设置用户问卷问题数据
export const setQuestion = (data) => {
  return serviceAxios({
    url: "/PCwj/questionTemp/setQuestion",
    method: "post",
    data,
  });
};

// 查询用户问卷问题列表
export const questionTempList = (params) => {
  return serviceAxios({
    url: "/PCwj/questionTemp/questionTempList",
    method: "get",
    params,
  });
};

// 题目分析
export const questionAnalysis = (query) => {
  return serviceAxios({
    url: "/wj/questionnaireRecord/questionAnalysis",
    method: "get",
    params: query,
  });
};

// 模板详情
export const questionnaireTemplate = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaireTemplate/questionnaireTemplateDetail",
    method: "post",
    data,
  });
};

// 用户编辑问卷详情(编辑页)
export const questionnaireUpdateDetail = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaire/questionnaireUpdateDetail",
    method: "post",
    data,
  });
};

// 免费使用模板详情
export const useQuestionnaireTemplate = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaireTemplate/useQuestionnaireTemplate",
    method: "post",
    data,
  });
};

// 数据导出
export const exportData = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaireRecord/export",
    method: "post",
    data,
  });
};

// 数据置顶
export const setQuestionnaireTop = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaire/setQuestionnaireTop",
    method: "post",
    data,
  });
};

// 数据统计分析
export function questionnaireDataList(query) {
  return serviceAxios({
    url: "/PCwj/questionnaireRecord/questionnaireDataList",
    method: "get",
    params: query,
  });
}

// 数据统计分析问卷详情
export const questionnaireDetail = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaire/questionnaireDetail",
    method: "post",
    data,
  });
};

// 主题列表
export function getThemeList(query) {
  return serviceAxios({
    url: "/PCwj/theme/themeList",
    method: "get",
    params: query,
  });
}

// 创建(修改)问题库
export const createPCUserLibrary = (data) => {
  return serviceAxios({
    url: "/PCwj/userLibraryType/createPCUserLibrary",
    method: "post",
    data,
  });
};

// 获取题库列表
export function userLibraryList(query) {
  return serviceAxios({
    url: "/PCwj/userLibraryType/userLibraryList",
    method: "get",
    params: query,
  });
}

// 获取题库问题列表-我的题库
export function myLibraryQuestionList(query) {
  return serviceAxios({
    url: "/PCwj/userLibraryType/libraryQuestionList",
    method: "get",
    params: query,
  });
}

// 获取题库问题列表-常用题库
export function cyLibraryQuestionList(query) {
  return serviceAxios({
    url: "/PCwj/libraryType/questionList",
    method: "get",
    params: query,
  });
}

// 创建(修改)问题库
export const createPCUserLibraryQuestion = (data) => {
  return serviceAxios({
    url: "/PCwj/userLibraryType/createPCUserLibraryQuestion",
    method: "post",
    data,
  });
};

// 删除题库问题
export const deletePCUserLibraryQuestion = (data) => {
  return serviceAxios({
    url: "/PCwj/userLibraryType/deletePCUserLibraryQuestion",
    method: "post",
    data,
  });
};

// PC常用题库
export const libraryList = (query) => {
  return serviceAxios({
    url: "/PCwj/libraryType/libraryList",
    method: "get",
    params: query,
  });
};

// 添加常用题库全部问题到项目
export const addLibraryToQuestionnaire = (data) => {
  return serviceAxios({
    url: "/PCwj/questionTemp/addLibraryToQuestionnaire",
    method: "post",
    data,
  });
};

// 添加用户题库全部问题到项目
export const addUserLibraryToQuestionnaire = (data) => {
  return serviceAxios({
    url: "/PCwj/questionTemp/addUserLibraryToQuestionnaire",
    method: "post",
    data,
  });
};

// 添加问题到项目
export const addQuestionToQuestionnaire = (data) => {
  return serviceAxios({
    url: "/PCwj/questionTemp/addQuestionToQuestionnaire",
    method: "post",
    data,
  });
};

// 文字转换成问题
export const convertQuestion = (data) => {
  return serviceAxios({
    url: "/PCwj/userLibraryType/convertQuestion",
    method: "post",
    data,
  });
};

// 添加题目到题库
export const addQuestionsToBank = (data) => {
  return serviceAxios({
    url: "/PCwj/userLibraryType/addQuestionsToBank",
    method: "post",
    data,
  });
};

// 删除问题库
export const deleteUserLibrary = (data) => {
  return serviceAxios({
    url: "/PCwj/userLibraryType/deleteUserLibrary",
    method: "post",
    data,
  });
};

// 获取问卷链接
export const getUrlLink = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaire/getUrlLink",
    method: "post",
    data,
  });
};

// 问卷问卷二维码 type: 2是模版    1是问卷
export const generateQRCode = (data) => {
  return serviceAxios({
    url: "/PCwj/questionnaireTemplate/generateQRCode",
    method: "post",
    data,
  });
};

// 根据活动UUID查询题目列表,交叉分析选择列表
export const questionsAnalyList = (query) => {
  return serviceAxios({
    url: "/PCwj/analyze/questionsList",
    method: "get",
    params: query,
  });
};

// 交叉分析
export const crossAnalysis = (data) => {
  return serviceAxios({
    url: "/PCwj/analyze/crossAnalysis",
    method: "post",
    data,
  });
};

// AI创建问卷
export const AICreateNew = (data) => {
  return serviceAxios({
    url: "/wj/questionnaire/AICreateNew",
    method: "post",
    data,
  });
};

// 获取启用状态的微信分享图片分类列表
export const getShareTypeList = (query) => {
  return serviceAxios({
    url: "/PCwj/wxShareImage/typeList",
    method: "get",
    params: query,
  });
};

// 获取微信分享图片列表
export const getShareImageList = (query) => {
  return serviceAxios({
    url: "/PCwj/wxShareImage/list",
    method: "get",
    params: query,
  });
};

// 获取添加管理员图
export const getManageQrcode = (query) => {
  return serviceAxios({
    url: "/PCwj/collaborator/qrcode",
    method: "get",
    params: query,
  });
};

// 根据Code获取用户信息
export const getOauth = (query) => {
  return serviceAxios({
    url: "/PCwj/tencentDocs/oauth/token",
    method: "get",
    params: query,
  });
};

// 根据问卷uuid导出excel到腾讯文档中
export const createByUuid = (formData) => {
  return serviceAxios({
    url: "/PCwj/tencentDocs/sheets/create-by-uuid",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 获取excel列表的接口
export const files = (query) => {
  return serviceAxios({
    url: "/PCwj/tencentDocs/files",
    method: "get",
    params: query,
  });
};

// 根据uuid和文件id追加 数据到腾讯文档中
export const appendByUuid = (formData) => {
  return serviceAxios({
    url: "/PCwj/tencentDocs/sheets/append-by-uuid",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 退出腾讯文档
export const exit = (query) => {
  return serviceAxios({
    url: "/PCwj/tencentDocs/exit",
    method: "get",
    params: query,
  });
};

// 获取腾讯文档地址及code
export const getConfiguration = (query) => {
  return serviceAxios({
    url: "/PCwj/tencentDocs/configuration",
    method: "get",
    params: query,
  });
};


// 获取飞书文档地址及code
export const getFeiShuConfiguration = (query) => {
  return serviceAxios({
    url: "/PCwj/feiShuDocs/configuration",
    method: "get",
    params: query,
  });
};

// 根据Code获取用户信息飞书
export const getFeiShuOauth = (query) => {
  return serviceAxios({
    url: "/PCwj/feiShuDocs/oauth/token",
    method: "get",
    params: query,
  });
};

// 退出飞书文档
export const exitFeiShu = (query) => {
  return serviceAxios({
    url: "/PCwj/feiShuDocs/exit",
    method: "get",
    params: query,
  });
};


// 根据问卷uuid导出excel到飞书文档中
export const createByUuidFeiShu = (formData) => {
  return serviceAxios({
    url: "/PCwj/feiShuDocs/sheets/create-by-uuid",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// 获取飞书excel列表的接口
export const filesFeiShu = (query) => {
  return serviceAxios({
    url: "/PCwj/feiShuDocs/files",
    method: "get",
    params: query,
  });
};

// 根据uuid和文件id追加 数据到飞书文档中
export const appendByUuidFeiShu = (formData) => {
  return serviceAxios({
    url: "/PCwj/feiShuDocs/sheets/append-by-uuid",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 获取飞书文档地址及code
export const getFeiShuLoginConfiguration = (query) => {
  return serviceAxios({
    url: "/PCwj/feiShuLogin/configuration",
    method: "get",
    params: query,
  });
};


// 根据Code获取用户信息飞书
export const getFeiShuLoginOauth = (query) => {
  return serviceAxios({
    url: "/PCwj/feiShuLogin/oauth/token",
    method: "get",
    params: query,
  });
};

// 
export const feiShuBindUser = (formData) => {
  return serviceAxios({
    url: "/PCwj/feiShuLogin/bindUser",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// WEBPACK FOOTER //
// ./src/api/index.js